export default function getUserDataUrl({ userName }, isLibraryPath = false) {
  return `/user/${userName}${isLibraryPath ? '/favorites/' : '/'}`;
}
